import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { NbAuthModule } from '@nebular/auth';
import { SmartTableQueryInterceptor } from './interceptors/smart-table-query-interceptor';
import { AuthorData } from './interfaces/author';
import { BookData } from './interfaces/book';
import { PersonData } from './interfaces/person';
import { AuthorService } from './services/author.service';
import { BookService } from './services/book.service';
import { PersonService } from './services/person.service';
import { UsersApi } from './api/users.api';
import { UserRolesApi } from './api/roles.api';
import { SettingsApi } from './api/settings.api';
import { HttpService } from './services/common/http.service';
import { LeaveRequestsData } from './interfaces/leave-request';
import { LeaveRequestsService } from './services/leave-requests.service';
import { DepartmentData } from './interfaces/department';
import { DepartmentsService } from './services/departments.service';
import { AssignmentData } from './interfaces/assignment';
import { AssignmentService } from './services/assignment.service';
import { RoleData } from './interfaces/role';
import { RoleService } from './services/role.service';
import { AlertService } from './utils/alert.service';
import { EntityService } from './utils/entity.service';
import { AppraisalData, OKRData } from './interfaces/performance';
import { OKRService } from './services/okr.service';
import { AppraisalService } from './services/appraisal.service';
import { TrainingData, TrainingResultData } from './interfaces/training';
import { TrainingService } from './services/training.service';
import { TrainingResultService } from './services/training-result.service';
import { JobPostingsService } from './services/job-posting.service';
import { ApplicationService } from './services/application.service';
import { ApplicationData } from './interfaces/application';
import { JobPostingData } from './interfaces/job-posting';
import { TaskData } from './interfaces/task';
import { TasksService } from './services/task.service';
import { ReviewData } from './interfaces/review';
import { ReviewService } from './services/review.service';
import { InternalDocService } from './services/internal-doc.service';
import { InternalDocData } from './interfaces/internal-doc';
import { PayrollPeriodData } from './interfaces/payroll-period';
import { PayrollPeriodService } from './services/payroll-period.service';
import { SalaryStructureData } from './interfaces/salary-structure';
import { SalaryStructureService } from './services/salary-structure.service';
import { PayrollCycleData } from './interfaces/payroll-cycle';
import { PayrollCycleService } from './services/payroll-cycle.service';

const APIS = [
  UsersApi,
  UserRolesApi,
  SettingsApi,
  HttpService,
  AlertService,
  EntityService
  // backend apis go here
];

const SERVICES_WITH_ABSTRACT_CLASS = [
  // services with abstract classes go here
  { provide: BookData, useClass: BookService },
  { provide: PersonData, useClass: PersonService },
  { provide: AuthorData, useClass: AuthorService },
  { provide: DepartmentData, useClass: DepartmentsService },
  { provide: LeaveRequestsData, useClass: LeaveRequestsService },
  { provide: AssignmentData, useClass: AssignmentService },
  { provide: OKRData, useClass: OKRService },
  { provide: AppraisalData, useClass: AppraisalService },
  { provide: TrainingData, useClass: TrainingService },
  { provide: TrainingResultData, useClass: TrainingResultService },
  { provide: RoleData, useClass: RoleService },
  { provide: JobPostingData, useClass: JobPostingsService },
  { provide: ApplicationData, useClass: ApplicationService },
  { provide: TaskData, useClass: TasksService },
  { provide: ReviewData, useClass: ReviewService },
  { provide: InternalDocData, useClass: InternalDocService },
  { provide: PayrollCycleData, useClass: PayrollCycleService },
  { provide: PayrollPeriodData, useClass: PayrollPeriodService },
  { provide: SalaryStructureData, useClass: SalaryStructureService },
];

@NgModule({
  imports: [CommonModule, NbAuthModule],
})
export class CommonBackendModule {
  static forRoot(): ModuleWithProviders<CommonBackendModule> {
    return {
      ngModule: CommonBackendModule,
      providers: [
        ...APIS,
        ...SERVICES_WITH_ABSTRACT_CLASS,
        { provide: HTTP_INTERCEPTORS, useClass: SmartTableQueryInterceptor, multi: true },
      ],
    };
  }
}